import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partnership_program: {
        promo_codes: {
          header: 'HEADER',
          create_button: 'CREATE_BUTTON',
          create: {
            header: 'CREATE_HEADER',
            back: 'CREATE_BACK',
            save: 'CREATE_SAVE',
            form: {
              promo_code: 'FORM_PROMO_CODE',
              tracker: 'FORM_TRACKER',
            },
          },
        },
      },
    },
  }));
}
